export enum ErrorCodeMessages {
  Error415Message = "Server is not available.",
  Error430Message = "Account still not activated. Please follow the link we just sent to your email to activate this account.",
  Error433Message = "Invalid credentials.",
  Error434Message = "This email is associated with existing user.",
  Error500Message = "Server is not available.",
}
